import { useState } from 'react';

import { Box, Button, H1, Icon, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { Flex } from '@betterment/samba-styled-system/jsx';
import { SambaAutoLink } from '@betterment/shared-components';
import { ListRow, Modal } from '@betterment/style-closet-react';

import { urlBuilder } from '../../Shared/urlBuilder';
import { CheckingOptionInManualReview } from '../hooks/useProductOnboardingOptions';

type Props = { option: CheckingOptionInManualReview };

export const CheckingOptionInManualReviewRow: React.FC<Props> = ({ option }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);

  return (
    <>
      <ListRow variant="expanded" data-testid="specCheckingManualReview">
        <ListRow.Slot name="leading">
          <Flex flexDirection="row" alignItems="center">
            <img
              src={option.image.light}
              alt={option.name}
              className={css({
                // TODO: replace with size token
                width: '36px',
                height: '36px',
                borderRadius: 'medium',
                objectFit: 'cover',
                marginLeft: 'space.100',
                marginRight: 'space.150',
              })}
            />
            <Flex flexDirection="column" justifyContent="center" alignItems="start">
              <Text variant="text100">{option.name}</Text>
              <Text variant="text50" color="text.weak">
                Pending
              </Text>
            </Flex>
          </Flex>
        </ListRow.Slot>
        <ListRow.Slot name="trailing">
          {option.isInManualReviewWithDocumentsRequired ? (
            <SambaAutoLink
              variant="solidSecondary"
              spacing="compact"
              to={urlBuilder.getCheckingMultidocUploadPage.absolute()}
            >
              Upload ID
            </SambaAutoLink>
          ) : (
            <Button
              variant="ghostPrimary"
              spacing="compact"
              onClick={openModal}
              css={{ marginRight: 'space.100' }}
              data-testid="specInReviewButton"
            >
              In review
            </Button>
          )}
        </ListRow.Slot>
      </ListRow>
      {isModalOpen && (
        <Modal contentWidth={['100%', '840px']} closeHandler={closeModal} label="application in review">
          <Box css={{ padding: 'space.400' }}>
            <Icon name="DocumentReview" size="large" />
            <H1 css={{ marginY: 'space.200' }}>Checking application submitted and in review</H1>
            <Text as="p">
              We'll email you when we've finished reviewing your application, which should be within{' '}
              <strong>1–2 business days</strong>. If approved, we’ll automatically open your account for you.
            </Text>
            <Flex css={{ marginTop: 'space.300' }}>
              <Button onClick={closeModal}>Got it</Button>
            </Flex>
          </Box>
        </Modal>
      )}
    </>
  );
};
